/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_PlaceholderInputs */

const en_chat_placeholder = /** @type {(inputs: Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about a strain or growing…`)
};

const th_chat_placeholder = /** @type {(inputs: Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถามเรื่องสายพันธุ์หรือการปลูก…`)
};

const ja_chat_placeholder = /** @type {(inputs: Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about a strain or growing…`)
};

const fr_chat_placeholder = /** @type {(inputs: Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about a strain or growing…`)
};

const es_chat_placeholder = /** @type {(inputs: Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about a strain or growing…`)
};

const ru_chat_placeholder = /** @type {(inputs: Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about a strain or growing…`)
};

const zh_chat_placeholder = /** @type {(inputs: Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about a strain or growing…`)
};

const vi_chat_placeholder = /** @type {(inputs: Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hỏi về một giống hoặc cách trồng…`)
};

/**
* | output |
* | --- |
* | "Ask about a strain or growing…" |
*
* @param {Chat_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_placeholder = /** @type {((inputs?: Chat_PlaceholderInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_PlaceholderInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_placeholder(inputs)
	if (locale === "ja") return ja_chat_placeholder(inputs)
	if (locale === "fr") return fr_chat_placeholder(inputs)
	if (locale === "es") return es_chat_placeholder(inputs)
	if (locale === "ru") return ru_chat_placeholder(inputs)
	if (locale === "zh") return zh_chat_placeholder(inputs)
	if (locale === "vi") return vi_chat_placeholder(inputs)
	return en_chat_placeholder(inputs)
});